export default __webpack_public_path__ + "static/media/actual-test.ae2abb80.svg";